<template>
  <salary-open-card v-if="isSalaryQuestion" :question="question" />
  <variable-open-card v-else :question="question" />
</template>

<script>
import { mapGetters } from 'vuex';

import VariableOpenCard from './open-cards/VariableOpenCard.vue';
import SalaryOpenCard from './open-cards/SalaryOpenCard.vue';


export default {
  name: 'CashflowCategoryOpenCard',
  components: {
    VariableOpenCard,
    SalaryOpenCard,
  },
  props: {
    question: Object,
  },
  computed: {
    ...mapGetters('cashflowCategoryActions', ['suggestedAnswers']),
    isSalaryQuestion() {
      return this.question.suggestedAnswer === this.suggestedAnswers.SALARY;
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/investigations/cashflow-category/cashflow-category/CashflowCategoryOpenCard.vue